var _a;
import { MainGroupConfiguration } from "../../data";
export var MainGroupFunctions = (_a = {},
    _a[MainGroupConfiguration.Sport] = {
        headings: "displaySports",
        events: "displayEventsBySportId"
    },
    _a[MainGroupConfiguration.League] = {
        headings: "displayLeagues",
        events: "displayEventsByLeague"
    },
    _a[MainGroupConfiguration.Day] = {
        headings: "displayDays",
        events: "displayEventsByDay"
    },
    _a[MainGroupConfiguration.Event] = {
        headings: "displayAllEvents",
        events: "displayEventsById"
    },
    _a);
//# sourceMappingURL=MainGroupFunctions.js.map